<app-header [menuList$]="menuList$" [memberInfo$]="memberInfo$"></app-header>

<app-sub-header [currMenu]="currMenu$" [memberInfo]="memberInfo$"></app-sub-header>

<div class="inner-wrap">

  <ul class="paid-tab">
    <li><span>01.</span>약관동의 및 유료회원 결제</li>
    <li class="active"><span>02.</span>가입완료</li>
  </ul>

  <div class="paid-step2">
    <div class="img"></div>
    <div class="msg">유료회원 전환<br/><span>가입 완료</span></div>
    <div class="btn-area">
      <a routerLink="/" class="btn1 main-btn">메인</a>
    </div>
  </div>

</div>

<app-footer></app-footer>